/**
 * The count bubble inside a Billing Manager tab trigger.
 *
 * Shared by the claims status tabs (EOEClaimsManager) and the remittance status
 * tabs (RemittanceManager) so both pipelines render an identical pill. The
 * `group-data-[state=active]` classes require the tab trigger to carry `group`.
 */
export const TabCountPill = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => (
  <span
    aria-label={
      value === '-' ? `${label} count unavailable` : `${label} count ${value}`
    }
    className='inline-flex h-4 min-w-5 shrink-0 items-center justify-center rounded-full bg-background/80 px-1.5 text-[10px] font-semibold leading-none text-muted-foreground tabular-nums ring-1 ring-border/60 group-data-[state=active]:bg-white/20 group-data-[state=active]:text-white group-data-[state=active]:ring-white/25'
  >
    {value}
  </span>
);
